import { AppSider } from 'shared/UI/UIKit/Sider';
import { TableFilter } from 'common/TableFilter';
import { CreateRoomModal } from '../../Modals/Create';
import { roomsFilterFields } from '../config';
import { useBuilding } from '../model';
import { RoomsTableControls } from '../../Controls';
import { EditRoomModal } from '../../Modals/Edit';
import { RemoveRoomModal } from '../../Modals/Remove';
import { RoomsTable } from '../../Table';
import { CopyRoomModal } from '../../Modals/Copy';

export const Building = () => {
  const {
    state: {
      visibleKeys,
      columns,
      createModalVisible,
      filterCount,
      filterState,
      filteredColumns,
      selectedRoom,
      siderVisible,
      loading,
      removeModalVisible,
      rooms,
      tableState,
      buildingId,
      editModalVisible,
      copyModalVisible,
    },
    methods: {
      setCreateModalVisible,
      hideEditModal,
      setRemoveModalVisible,
      setVisibleKeys,
      showSider,
      onFilterChange,
      onItemRemove,
      onTableChange,
      hideSider,
      refreshPage,
      createRoom,
      hideCopyModal,
    },
  } = useBuilding();

  return (
    <>
      <RoomsTableControls
        visibleKeys={visibleKeys}
        columns={columns}
        setVisibleKeys={setVisibleKeys}
        showSider={showSider}
        filterCount={filterCount}
        createRoom={createRoom}
      />
      <RoomsTable
        columns={filteredColumns}
        loading={loading}
        dataSource={rooms}
        tableState={tableState}
        onChange={onTableChange}
      />
      <CreateRoomModal
        selectedRoom={selectedRoom}
        buildingId={buildingId}
        visible={createModalVisible}
        hide={() => setCreateModalVisible(false)}
        onItemCreate={refreshPage}
      />
      <EditRoomModal
        selectedRoom={selectedRoom}
        visible={editModalVisible}
        hide={hideEditModal}
        buildingId={buildingId}
        onItemEdit={refreshPage}
      />
      <RemoveRoomModal
        selectedRoom={selectedRoom}
        visible={removeModalVisible}
        hide={() => setRemoveModalVisible(false)}
        onItemRemove={onItemRemove}
      />
      <CopyRoomModal
        selectedRoom={selectedRoom}
        visible={copyModalVisible}
        hide={hideCopyModal}
        buildingId={buildingId}
        onItemCopy={refreshPage}
      />
      <AppSider
        title="Фильтры"
        isSiderVisible={siderVisible}
        submitBtnText="Применить"
        cancelBtnText="Сбросить всё"
        hideSider={hideSider}
      >
        <TableFilter
          fields={roomsFilterFields}
          submitBtnText="Применить"
          resetBtnText="Сбросить всё"
          onSubmit={onFilterChange}
          onClose={hideSider}
          fieldsValue={filterState}
        />
      </AppSider>
    </>
  );
};
